(() => {
  const app = window.Sendhilsen || {};
  const routes = app.routes || {};
  const collections = app.collections || {};
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const screens = {
    hero: $('#hero'), occasion: $('#occasions'), cards: $('#card-selector'), custom: $('#custom-card'), message: $('#message-writer')
  };
  const homeSections = $$('[data-home-section]');
  const cardGrid = $('[data-card-grid]');
  const cardTitle = $('[data-card-occasion-title]');
  const messageProductTitle = $('[data-message-card-title]');
  const recipient = $('#recipient-name');
  const message = $('#custom-message');
  const counter = $('[data-char-count]');
  const submit = $('[data-add-to-cart]');
  const fontGroup = $('[data-font-group]');
  let selectedProduct = null;
  let customImageData = null;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const money = cents => {
    if (window.Shopify?.formatMoney && app.moneyFormat) return Shopify.formatMoney(cents, app.moneyFormat);
    return new Intl.NumberFormat('nb-NO', { style: 'currency', currency: app.currency || 'NOK', maximumFractionDigits: 0 }).format(cents / 100);
  };
  const showHome = () => {
    Object.values(screens).forEach(screen => screen?.classList.add('hidden'));
    screens.hero?.classList.remove('hidden');
    homeSections.forEach(section => section.classList.remove('hidden'));
    document.body.classList.remove('flow-active');
    window.scrollTo({ top: 0 });
  };
  const showStep = (name, push = true) => {
    Object.values(screens).forEach(screen => screen?.classList.add('hidden'));
    homeSections.forEach(section => section.classList.add('hidden'));
    screens[name]?.classList.remove('hidden');
    document.body.classList.add('flow-active');
    if (push) history.pushState({ sendhilsenStep: name }, '');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const resetMessage = product => {
    selectedProduct = product;
    if (messageProductTitle) messageProductTitle.textContent = product.title.toLowerCase();
    if (recipient) recipient.value = '';
    if (message) message.value = '';
    if (counter) counter.textContent = '0';
    const handwritten = $('input[name="writing-style"][value="handwritten"]');
    if (handwritten) handwritten.checked = true;
    fontGroup?.classList.add('hidden');
    validate();
  };
  const renderCards = collection => {
    if (!cardGrid) return;
    cardTitle.textContent = collection.title;
    cardGrid.innerHTML = collection.products.length ? collection.products.map(product => `
      <button class="card-option" type="button" data-product-handle="${escapeHtml(product.handle)}">
        <div class="card-image-wrap">${product.image ? `<img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}</div>
        <h2 class="card-title">${escapeHtml(product.title)}</h2><p class="card-price">${money(product.priceRaw)}</p>
      </button>`).join('') : '<p>Ingen kort funnet.</p>';
    cardGrid.onclick = event => {
      const button = event.target.closest('[data-product-handle]');
      if (!button) return;
      const product = collection.products.find(item => item.handle === button.dataset.productHandle);
      if (!product) return;
      customImageData = null;
      resetMessage(product);
      showStep('message');
    };
    showStep('cards');
  };
  const validate = () => {
    if (!submit) return;
    submit.disabled = !(recipient?.value.trim() && message?.value.trim().length > 10);
  };
  const updateWritingStyle = () => {
    const printed = $('input[name="writing-style"]:checked')?.value === 'printed';
    fontGroup?.classList.toggle('hidden', !printed);
    const family = printed ? $('input[name="font"]:checked')?.value : 'Playfair Display';
    if (message) message.style.fontFamily = family ? `'${family}'` : '';
  };
  const fetchCart = async () => {
    const response = await fetch(routes.cart || '/cart.js');
    if (!response.ok) throw new Error('Kunne ikke hente handlekurven');
    return response.json();
  };
  const updateCartUI = cart => {
    if (!cart) return;
    const count = $('[data-cart-count]');
    const total = $('[data-cart-total]');
    const body = $('[data-cart-body]');
    if (count) count.textContent = cart.item_count ? String(cart.item_count) : '';
    if (total) total.textContent = money(cart.total_price);
    if (!body) return;
    body.innerHTML = cart.items?.length ? cart.items.map(item => `<article class="cart-item">
      <div class="cart-item-image">${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">` : ''}</div>
      <div><h3 class="cart-item-title">${escapeHtml(item.product_title)}</h3>${Object.entries(item.properties || {}).filter(([,v]) => v).map(([k,v]) => `<p class="cart-item-property"><strong>${escapeHtml(k)}:</strong> ${escapeHtml(v)}</p>`).join('')}</div>
      <div class="cart-item-qty"><button type="button" data-qty="${item.key}" data-value="${Math.max(0,item.quantity-1)}">−</button><input readonly value="${item.quantity}" aria-label="Antall"><button type="button" data-qty="${item.key}" data-value="${item.quantity+1}">+</button></div>
    </article>`).join('') : '<div class="cart-empty"><p>Handlekurven er tom</p></div>';
  };
  const openCart = async () => {
    try { updateCartUI(await fetchCart()); } catch (error) { console.error(error); }
    $('#cart-drawer')?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const addAndCheckout = async () => {
    if (!selectedProduct || submit.disabled) return;
    submit.disabled = true; submit.textContent = 'Sender …';
    const writingStyle = $('input[name="writing-style"]:checked')?.value || 'handwritten';
    const font = $('input[name="font"]:checked')?.value || 'Dancing Script';
    const properties = { 'Mottaker': recipient.value.trim(), 'Budskap': message.value.trim(), 'Skrivemåte': writingStyle === 'printed' ? 'Trykt tekst' : 'Håndskrevet' };
    if (writingStyle === 'printed') properties['Skrifttype'] = font;
    const customFile = $('[data-custom-card-image]')?.files?.[0];
    try {
      const formData = new FormData();
      formData.append('id', selectedProduct.variantId);
      formData.append('quantity', '1');
      Object.entries(properties).forEach(([key, value]) => formData.append(`properties[${key}]`, value));
      if (customFile) formData.append('properties[Eget bilde]', customFile, customFile.name);
      const response = await fetch(routes.cartAdd || '/cart/add.js', { method:'POST', body:formData });
      if (!response.ok) throw new Error((await response.json()).description || 'Kunne ikke legge til kortet');
      $('[data-checkout-submit]')?.click();
    } catch (error) { alert(error.message || 'Noe gikk galt. Prøv igjen.'); submit.disabled = false; submit.textContent = 'Send brev'; }
  };

  history.replaceState({ sendhilsenStep: 'hero' }, '');
  $$('[data-start-flow]').forEach(button => button.addEventListener('click', () => showStep('occasion')));
  $$('[data-start-custom]').forEach(button => button.addEventListener('click', () => showStep('custom')));
  $$('[data-back-home]').forEach(button => button.addEventListener('click', () => history.back()));
  $('[data-back-to-occasions]')?.addEventListener('click', () => history.back());
  $('[data-back-to-cards]')?.addEventListener('click', () => history.back());
  $$('[data-occasion]').forEach(button => button.addEventListener('click', () => { const collection = collections[button.dataset.occasion]; if (collection) renderCards(collection); }));
  $$('input[name="writing-style"],input[name="font"]').forEach(input => input.addEventListener('change', updateWritingStyle));
  recipient?.addEventListener('input', validate);
  message?.addEventListener('input', () => { counter.textContent = String(message.value.length); validate(); });
  submit?.addEventListener('click', addAndCheckout);
  $('[data-cart-toggle]')?.addEventListener('click', openCart);
  $('[data-cart-close]')?.addEventListener('click', () => { $('#cart-drawer')?.setAttribute('aria-hidden','true'); document.body.style.overflow=''; });
  $('[data-cart-overlay]')?.addEventListener('click', () => { $('#cart-drawer')?.setAttribute('aria-hidden','true'); document.body.style.overflow=''; });
  $('[data-cart-body]')?.addEventListener('click', async event => { const button = event.target.closest('[data-qty]'); if (!button) return; const response = await fetch(routes.cartUpdate || '/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:{[button.dataset.qty]:Number(button.dataset.value)}})}); if(response.ok) updateCartUI(await response.json()); });
  const upload = $('[data-custom-card-image]');
  upload?.addEventListener('change', () => { const file = upload.files?.[0]; if (!file || file.size > 15*1024*1024) return; const reader = new FileReader(); reader.onload = () => { customImageData = String(reader.result); const preview = $('[data-custom-card-preview]'); preview.src = customImageData; preview.classList.remove('hidden'); $('[data-custom-card-next]').disabled = !app.customProduct; }; reader.readAsDataURL(file); });
  $('[data-custom-card-next]')?.addEventListener('click', () => { if (!app.customProduct || !customImageData) return; resetMessage(app.customProduct); showStep('message'); });
  addEventListener('popstate', event => { const step = event.state?.sendhilsenStep || 'hero'; step === 'hero' ? showHome() : showStep(step, false); });
  fetchCart().then(updateCartUI).catch(console.error);
})();
